export default __webpack_public_path__ + "static/media/BrixSansMedium.929cd673.woff2";